import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button, Checkbox } from "antd";
import config from '../../config/form.json'
import { orgmode,showloader, CompanyType, productSelection, products, partners } from "../../store/gloabalState";
import { useRecoilValue, useSetRecoilState } from "recoil";
import SectionHeading from "./section-headings";
import useNotify from "../../utils/useNotify";
import Cookies from "js-cookie";
import { updateOrg } from '../../services/httpCalls';
import YesLogo from '../../assets/images/yes.png';
import XflowLogo from '../../assets/images/xflow.png';
import PayGlocalLogo from '../../assets/images/payGlocal.png';
import IDFCLogo from '../../assets/images/idfc.png';
import RBLLogo from '../../assets/images/rbl.png';
import DBSLogo from '../../assets/images/dbs.png';

const Products = ({ handleChange, orgDetails }) => {   
    // initializing form
    const [form] = Form.useForm();

    // getting basic info config
    const configData = config.products[0];

    // local states
    const [disableBtn, setDisableBtn] = useState(true)
    const [isInward, setIsInward] = useState(false)
    const [isOutward, setIsOutward] = useState(false)
    const [payload, setPayload] = useState({})
    const [forceUpdate, setForceUpdate] = useState(0);

    // global states

    // values
    const mode = useRecoilValue(orgmode)

    // updater/setter
    let setSelectionValue = useSetRecoilState(productSelection)
    let setProductsSelected = useSetRecoilState(products)
    let setPartners = useSetRecoilState(partners);



    // states
    

    // constants/binders
    const notify = useNotify();
    const YesLogoInstance = YesLogo;
    const IDFCLogoInstance = IDFCLogo;
    const XflowLogoInstance = XflowLogo;
    const PayGlocalLogoInstance = PayGlocalLogo;
    const RBLogoInstance = RBLLogo;
    const DBSLogoInstance = DBSLogo;
    const companyTypes = localStorage.getItem('CompanyType') ? localStorage.getItem('CompanyType') : ""
    const isCompanyTypeSoleOrFreelancer = ((orgDetails?.companyType === "SOLE_PRORIETOR") || (companyTypes === "SOLE_PRORIETOR") || (orgDetails?.companyType === "FREELANCER"))

    const next = async (values) => {
        
        // TODO selection_arr will be used later
        const selection_arr = [];

        // this is for storing data globally
        const partner_arr = [];
        let payload_list = {}

        Object.keys(values).forEach((key, index) => {

            const value = values[key]

            let newKey = key.replace(/-/g, '');
            payload_list[newKey] = (payload && (payload?.[key] !== undefined)) ? payload?.[key] : orgDetails?.[newKey] ? orgDetails?.[newKey] : false;
            
            if(value?.[0]) {
            let pair = key.split('-');

            if(!selection_arr.includes(pair[0])) 
                selection_arr.push(pair[0])

            if(!partner_arr.includes(pair[1]))
                partner_arr.push(pair[1])


            payload_list[newKey] = true;
            }    

        })
        const inward_arr = [];
        const outward_arr = [];

        let inward = false;
        let outward = false;

        Object.keys(payload_list).forEach((key, index) => {

            const value = payload_list[key]

            if(key && key.includes('inward') && value) {
                inward_arr.push(true)
            }
            if(key && key.includes('outward') && value) {
                outward_arr.push(true);
            }
        })

            if(inward_arr.some(inward => inward === true)){
                inward = true;
            } else {
                inward = false;
            }
            if(outward_arr.some((outward)=> outward === true)){
                outward = true;
            } else {
                outward = false;
            }
        setPartners(partner_arr);
        if(Object.keys(payload_list).some((key) => payload_list[key])){
        if(isCompanyTypeSoleOrFreelancer) {
                let data = {
                    ...payload_list,
                    "isOptInward" : inward,
                    isOptOutward: outward,
                    tosAcceptanceTime: Date.now(),
                    tosAcceptanceUserAgent: navigator.userAgent,
                }
                let orgId = localStorage.getItem("orgId")
                await updateOrg(data, orgId)
                    .then((res) => {
                        if(res) {
                            localStorage.setItem("orgId", res.id)
                            Cookies.set("currentStage", "2")
                            Cookies.set("products", 'inward')
                            notify.success("Products selected!")
                            handleChange(2)         
                        }
                    })
                    .catch((err) => {
                        notify.error("Error encountered!")
                    })
        } 
        else {
            if (inward || outward) {
                let data = {
                    ...payload_list,
                    "isOptInward": inward,
                    "isOptOutward": outward,
                    tosAcceptanceTime: Date.now(),
                    tosAcceptanceUserAgent: navigator.userAgent,
                }
                let products
                if (inward && outward) {
                    products = 'both'
                    setSelectionValue("both")

                } else if (inward && !outward) {
                    products = 'inward'
                    setSelectionValue("inward")
                } else {
                    products = 'outward'
                    setSelectionValue("outward")
                }
                let orgId = localStorage.getItem("orgId")
                await updateOrg(data, orgId)
                    .then((res) => {
                        if (res) {
                            localStorage.setItem("orgId", res.id)
                            Cookies.set("currentStage", "2")
                            Cookies.set("products", products)
                            notify.success("Products selected!")
                            handleChange(2)
                        }
                    })
                    .catch((err) => {
                        notify.error("Products not selected!")
                    })
            }
        }
    } else {
        notify.error('Please select atleast one product!')
    }
    }

    useEffect(() => {
        setForceUpdate(prev => prev + 1);  // Increment the value to trigger re-render
    }, [orgDetails]);

    useEffect(() => {
        let products_ = []
        if (orgDetails?.isOptInward) {
            setSelectionValue("inward")
            setIsInward(true)
            products_.push('inward')
        }
        if (orgDetails?.isOptOutward) {
            setSelectionValue("outward")
            setIsOutward(true)
            products_.push('outward')
        }
        if (orgDetails?.isOptOutward && orgDetails?.isOptInward) {
            setSelectionValue("both")
        }
        setProductsSelected(products_)
    },[orgDetails, setProductsSelected, setSelectionValue])

    const handlePartnerChange = (selection, name, checked) => {
            setPayload((pay) => {
                return {
                    ...pay,
                    [name]: checked
                }
            })
    }

    const renderField = (field, index) => {
        const { type, label, name, props, style, tooltip} = field;

        // formatting rules
        field?.rules?.forEach(item => {
            if (item?.pattern) {
              item.pattern = eval(item?.pattern);
            } 
            if (item?.required) {
                item.required = eval(item?.required)
            }
            if (item?.validator) {
                item.validator = eval(item?.validator)
            }
        });        
        
        switch (type) {
            case 'Form.Item':
                return (
                    <React.Fragment key={index}>
                        <Form.Item
                            label={label}
                            name={name}
                            rules={field?.rules}
                            tooltip={tooltip}
                            labelCol={field?.labelCol}
                            required={eval(field?.required)}
                            valuePropName={field?.valuePropName}
                        >      
                                {field?.children ? renderField(field?.children, 0) : null }
                        </Form.Item>
                        {field?.subFields ? field?.subFields.map((child, childIndex) => renderField(child, childIndex)) : null}
                    </React.Fragment>
                )
            case 'SectionHeading':
                return (
                    <SectionHeading
                    key={index}
                        style={field?.style}
                        level={field?.level}
                        heading={field?.heading}
                        Col={field?.Col}
                    />
                );
            case 'Checkbox.Group':
                return (
                    <Checkbox.Group
                    key={index}
                        style={field?.style}
                        defaultValue={eval(props?.defaultValue)}
                        className="product-selection-group"
                    >
                        {field?.children ? field?.children?.map((child, childIndex) => renderField(child, childIndex)) : null}
                    </Checkbox.Group>
                );
            case 'Checkbox':
                return (
                    <Checkbox
                    key={index}
                        value={field?.value}
                        onChange={eval(props?.onChange)}
                        disabled={eval(props?.disabled)}
                        defaultValue={eval(props?.defaultValue)}
                    >
                            {field.hasOwnProperty('children') && renderField(field.children, 0 )}
                            {field?.label}
                    </Checkbox>
                );
            case 'img':
                return(
                    <img
                    key={index}
                        src={eval(field?.props?.src)}
                        alt={field?.props?.alt}
                        style={{
                            maxHeight: 32,
                            maxWidth: 120,
                            marginRight:'10px'
                        }}
                    />
                )
            default:
                return null;
        }
    }

    return (
            <Form
            key={forceUpdate}
            {...configData.formConfig}
            form={form}
            onFinish={next}
            disabled={mode === 'view'}
            >
              <Row gutter={[16,16]}>
                    {configData.fields.map((field, index) => {

                        const isFreelancer =  orgDetails?.companyType === "FREELANCER" ? field?.companyType?.includes("FREELANCER") : true;
                        const isCompanyTypeOthers = field?.companyType?.includes("OTHERS")

                        // conditional render
                        const modeCondition = mode !== "new" ? orgDetails : true;
                        const shouldRender = field?.isHeading || (isCompanyTypeSoleOrFreelancer ? isFreelancer : isCompanyTypeOthers);


                        return modeCondition && shouldRender && (
                            <Col key={index}  span={ field?.Col ? field.Col : 12}>
                                {renderField(field,index)}
                            </Col>
                        )
                    })}
                </Row>
                {mode !== "view" &&
                <div className='fixed_btn_wrap'>
                    <Button 
                        type="primary" 
                        style={{ marginLeft: ".5rem" }} 
                        htmlType="submit" 
                        disabled={companyTypes === "SOLE_PRORIETOR" ? false : false}
                       >
                            Next
                    </Button>
                </div>
                }
            </Form>
        )
}


export default Products;